var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57112 7.03556H2.89001C4.11773 7.03556 5.12223 8.04007 5.12223 9.26779V20.4289C5.12223 21.6566 4.11773 22.6611 2.89001 22.6611H2.57112C1.3434 22.6611 0.338898 21.6566 0.338898 20.4289V9.26779C0.338898 8.04007 1.3434 7.03556 2.57112 7.03556ZM11.5 0.338898C12.7277 0.338898 13.7322 1.3434 13.7322 2.57112V20.4289C13.7322 21.6566 12.7277 22.6611 11.5 22.6611C10.2723 22.6611 9.26779 21.6566 9.26779 20.4289V2.57112C9.26779 1.3434 10.2723 0.338898 11.5 0.338898ZM20.4289 13.0945C21.6566 13.0945 22.6611 14.099 22.6611 15.3267V20.4289C22.6611 21.6566 21.6566 22.6611 20.4289 22.6611C19.2012 22.6611 18.1967 21.6566 18.1967 20.4289V15.3267C18.1967 14.099 19.2012 13.0945 20.4289 13.0945Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDashboard);
export default __webpack_public_path__ + "static/media/mobile-dashboard.7819f142.svg";
export { ForwardRef as ReactComponent };